/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IRCreateIRRequest } from "../models/IRCreateIRRequest";
import type { IRCreateIRResponseApiRespoonse } from "../models/IRCreateIRResponseApiRespoonse";
import type { IRDeleteIRRequest } from "../models/IRDeleteIRRequest";
import type { IRDeleteIRResponseApiRespoonse } from "../models/IRDeleteIRResponseApiRespoonse";
import type { IREditIRRequest } from "../models/IREditIRRequest";
import type { IREditIRResponseApiRespoonse } from "../models/IREditIRResponseApiRespoonse";
import type { IRListIRRequest } from "../models/IRListIRRequest";
import type { IRListIRResponseApiRespoonse } from "../models/IRListIRResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class IrManagerService {
  /**
   * Get list IR
   * @param requestBody
   * @returns IRListIRResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static otherIr(
    requestBody: IRListIRRequest
  ): CancelablePromise<IRListIRResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/otherIr",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create IR
   * @param requestBody
   * @returns IRCreateIRResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static otherIrCreate(
    requestBody: IRCreateIRRequest
  ): CancelablePromise<IRCreateIRResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/otherIr/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update IR
   * @param requestBody
   * @returns IREditIRResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static otherIrEdit(
    requestBody: IREditIRRequest
  ): CancelablePromise<IREditIRResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/otherIr/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Delete IR
   * @param requestBody
   * @returns IRDeleteIRResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static otherIrDelete(
    requestBody: IRDeleteIRRequest
  ): CancelablePromise<IRDeleteIRResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/otherIr/delete",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
